var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 82,
    viewBox: "0 0 90 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON SOUND"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.0502 60.3015C20.8035 65.0211 13.9302 60.5291 10.7111 53.6207C7.49206 46.7123 10.4835 38.5006 17.3919 35.2816L26.618 31.2061C30.617 29.4373 34.0493 26.5999 36.5296 23.0111L46.4332 9.04227C47.9837 6.42839 68.2628 55.6138 68.2628 55.6138L58.3928 55.3553C55.8878 55.2931 53.3814 55.1542 50.9095 54.7757C46.5108 54.0999 41.9833 54.6792 37.8723 56.4658L29.0573 60.2982L29.0502 60.3015Z",
    stroke: "#FDF3DC",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.3921 35.2817L29.838 59.5563L35.1939 70.7737C35.1939 70.7737 37.5273 75.2833 41.9581 73.4079C44.9036 72.1643 43.8649 69.1234 43.3102 66.8628C42.7626 64.5989 39.0777 55.6206 39.0777 55.6206L27.4582 30.9609",
    stroke: "#FDF3DC",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M61.3681 20.5765L70.1439 9.44593",
    stroke: "#FDF3DC",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M66.8048 28.9964L73.904 24.8029",
    stroke: "#FDF3DC",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M70.1787 37.8614L81.2197 36.9982",
    stroke: "#FDF3DC",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSound);
export default __webpack_public_path__ + "static/media/icon-sound.066793cc944ba81334ee391975ee925b.svg";
export { ForwardRef as ReactComponent };